(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.droopler_subtheme = {
    attach: function (context, settings) {

      // Insert your code here.

    }
  };





})(jQuery, Drupal);
function myFunction() {
  var x = document.getElementById("pop");
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}
function myPop() {
  var x = document.getElementById("pop");
  x.style.display = "none";
}

(function($, Drupal, document) {

    /**
     * Add / remove 'filled' classname if input has a value
     */
    function checkInputFillState () {
      const $input = $(this);
      $input.parent().toggleClass('filled', !!$input.val());
    }

    Drupal.behaviors.formInput = {
        attach(context, settings) {

          $(once('form-input', '.form-type-textfield > input.form-text, .form-type-email > input.form-email, .form-type-tel > input.form-tel, .form-type-textarea > textarea.form-textarea', context))
            .on('blur keyup', checkInputFillState)
            .each(checkInputFillState);        
        }
    };
})(jQuery, Drupal);


(function($, Drupal, document) {

    /**
     * Add / remove 'filled' classname if input has a value
     */
    function checkInputFillState () {
      const $input = $(this);
      $input.parent().parent().toggleClass('filled', !!$input.val());
    }

    Drupal.behaviors.formInputTextarea = {
        attach(context, settings) {

          $(once('form-input', '.form-type-textarea > * > textarea.form-textarea', context))
            .on('blur keyup', checkInputFillState)
            .each(checkInputFillState);        
        }
    };
})(jQuery, Drupal);